/**
 * Created by Ning Jiang on 2024-02-01.
 */

import {TimelineLite} from "gsap";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {EGRStackedSymbol} from "./EGRStackedSymbol";
import {ElGordosRevengeSymbolState} from "./ElGordosRevengeSymbolConfig";
import {ElGordosRevenge} from "../ElGordosRevenge";
import {ElGordosRevengeSound} from "../sound/ElGordosRevengeSound";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {EGRS1Symbol} from "./EGRS1Symbol";
import {ElGordosRevengeLayers, Layers} from "../view/ElGordosRevengeLayers";
import {ElGordosRevengeBackground} from "../view/ElGordosRevengeBackground";

export class EGRS2Symbol extends EGRStackedSymbol {

    protected _fadeHole:boolean = true;

    constructor(symbolName:string, reelId:number, initState:ElGordosRevengeSymbolState) {
        super(symbolName, reelId, initState);

        if(ElGordosRevenge.model.isRestore && ElGordosRevenge.model.parsedInitData.nextMode === GameMode.FREESPIN_SUPER) {
            this.playRestore();
        }
    }

    protected getWildOffsetY():number {
        return 90;
    }

    protected getWildScale():number {
        return 1;
    }

    public playLanding(init:boolean = false):TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add([
            () => {
                this._deadCharacter.visible = true;
                this._deadCharacter.state.setAnimation(0, "S2_Landing", false);
                ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevenge.model.parsedGameData.nextMode === GameMode.FREESPIN_SUPER ? ElGordosRevengeSound.S2_LAND_UNLOCK_SFS : ElGordosRevengeSound.S2_LAND});
                ElGordosRevengeBackground.shakeStageOnce(0.4);
                ElGordosRevenge.background.playBoostAnimation(ElGordosRevenge.background.isBoostLooping ? true : false);
            }
        ]);
        tl.add([
            () => {
                this._deadCharacter.state.setAnimation(0, "S2_Loop", true);
                this.showWild(init);
            },
        ], `+=${this._deadCharacter.spineData.findAnimation("S2_Landing").duration}`);

        if(ElGordosRevenge.model.parsedGameData.mode === GameMode.NORMAL && ElGordosRevenge.model.parsedGameData.nextMode === GameMode.FREESPIN_SUPER) {
            let hasS1:boolean = false;
            ElGordosRevenge.model.parsedGameData.S1Positions.forEach((symId, reelId) => {
                if(symId > -1) {
                    const sym = <EGRS1Symbol>ElGordosRevenge.reels[reelId].getSymbol(symId);
                    tl.add(sym.playUpgrade(), 0.5);
                    hasS1 = true;
                }
            });
            if(hasS1) {
                tl.add(() => {
                    ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.SCATTER_UNLOCK_MASSACRE});
                }, 0.5);
            }
        }
        return tl;
    }

    private playRestore():void {
        this.createDeadContainer();
        this._deadCharacter.visible = true;
        this._deadCharacter.state.setAnimation(0, "S2_Loop", true);
        this.showWild(true);
    }

    public playOnShot():TimelineLite {
        const tl = new TimelineLite();
        tl.add(() => {
            Logger.logDev(`I am ${this._itemName}, I play on shot!`);
        });
        return tl;
    }

    protected getOnShotAnimationName():string {
        return "S2_Shoot";
    }

    protected getDeadLoopAnimationName():string {
        return `S2_Loop`;
    }

    protected getIndividualAnimationName():string {
        return `S2_Dead`;
    }

    protected getCharacterAssetName():string {
        return "S2";
    }

    private playUpgrade():TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add([
            () => {
                this._deadCharacter.visible = true;
                this._deadCharacter.state.setAnimation(0, "S2_Dead", false);
                // DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.S2_LAND});
                // DeadwoodRipBackground.shakeStageOnce(0.3);
            }
        ]);
        tl.add(() => {
            this._deadCharacter.state.setAnimation(0, "S2_Loop", true);
        }, `+=${this._deadCharacter.spineData.findAnimation("S2_Dead").duration}`);

        return tl;
    }

    public playWinSuper():TimelineLite {
        const position = this.getGlobalCenterPosition();
        const s2Win = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("S2Win"));
        s2Win.autoUpdate = true;
        s2Win.position.set(position.x, position.y);
        const tl = new TimelineLite();
        tl.add([
            () => {
                ElGordosRevengeLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(s2Win);
                s2Win.state.setAnimation(0, "S2_landing", false);
            },
            this.playUpgrade()
        ]);
        tl.add(() => {
            s2Win.state.setEmptyAnimations(0);
            s2Win.parent.removeChild(s2Win);
            s2Win.destroy();
        }, s2Win.spineData.findAnimation("S2_landing").duration);
        return tl;
    }

    public playCylinderStart():TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add([
            () => {
                this._deadCharacter.visible = true;
                this._deadCharacter.state.setAnimation(0, "S2_Cylinder", false);
                // DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.S2_LAND});
                // DeadwoodRipBackground.shakeStageOnce(0.3);
            }
        ]);
        tl.add(() => {
            this._deadCharacter.state.setAnimation(0, "S2_Loop", true);
        }, `+=${this._deadCharacter.spineData.findAnimation("S2_Cylinder").duration}`);
        return tl;
    }

    protected playKillSound():void {
        ElGordosRevengeSound.playSymbolKill("S", this.reelId);
    }
}